// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"61638c70","284":"ff3bba24","535":"9f5f1cc5","642":"517cf3ce","682":"c7f5d18d","816":"9f2d1e04","969":"18b4fb18"}[chunkId] + ".chunk.js";
};